import { render, staticRenderFns } from "./RemoteConsultationTableCmp6.vue?vue&type=template&id=276ce436&"
import script from "./RemoteConsultationTableCmp6.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports